import {
  IconCalendarCheck,
  IconCalendarClock,
  IconCalendarDot,
  IconCalendarExclamation,
  IconPhoneSpark,
} from '@tabler/icons-react';
import { useCompanyConfiguration } from 'init/use-company-configuration';
import { tKeys, useTranslation } from 'locales';
import { useMemo } from 'react';

import type { Menu, MenuItem } from '../types';

export function useBuildRemindersMenu(): Menu {
  const { t } = useTranslation();
  const company = useCompanyConfiguration();

  return useMemo(() => {
    const items: Array<MenuItem | Menu> = [
      {
        path: '/reminders/imminent',
        label: t(tKeys.NAV.IMINENT_REMINDERS),
        Icon: IconCalendarClock,
        unreadCount: company?.reminders_to_send_count?.next_five_days,
      },
      {
        path: '/reminders',
        label: t(tKeys.REMINDER_LIST.TITLE),
        Icon: IconCalendarCheck,
      },
      {
        path: '/reminders/failed',
        label: t(tKeys.FAILED_REMINDERS.MENU_LABEL),
        Icon: IconCalendarExclamation,
      },
      {
        path: '/reminders/ai-calls',
        label: t(tKeys.AI_CALLS.MENU_LABEL),
        Icon: IconPhoneSpark,
        showUpsell: !company.package?.can_use_ai_calls,
      },
    ];

    return {
      parent: null,
      label: t(tKeys.REMINDERS_MENU),
      Icon: IconCalendarDot,
      path: '/reminders/imminent',
      items,
    };
  }, [company, t]);
}
